export default __webpack_public_path__ + "static/media/copy-2.c392b09d.svg";